import { defineMessages } from 'react-intl'

export const strings = defineMessages({
  "BIO_P_ONE": {
    "id":"bio-p-one",
    "defaultMessage":"Photography has not played, until recently, a large role in my life. I attended Middlebury College where I majored both in philosophy and religion. Upon graduation I decided to pursue a career in professional hockey but quickly decided that intellectual pursuits were more important. I received Rabbinic Ordination from the Jewish Theological Seminary of America (1982) and a Ph.D. from Brandeis University (1987) in Modern Jewish Philosophy.  I taught at The University of Delaware. Vassar College and Brandeis University and have held two Rabbinic posts, the last in Pelham, NY. I am the author of Abraham Heschel's Idea of Revelation (Scholars Press, 1989) and The Eclipse of Humanity; Heschel's critique of heideger (Dele Gruyter, 2016)."
  },
  "PURCHASE": {
    "id":"purchase",
    "defaultMessage": "PURCHASE"
  }
})



// WEBPACK FOOTER //
// ../messages/strings.js